import React from "react";
import PropTypes from "prop-types";
import { ErrorBoundary } from "react-error-boundary";
import { useExpertProfileContext } from "@limitless/expert";
import { log as pilog } from "@limitless/common/utils";
import fallbackRender from "./ErrorBoundary";

const ErrorBoundaryWrapper = ({ children }) => {
    const log = pilog.getLogger("ErrorBoundary");

    const { profile } = useExpertProfileContext();
    const handleError = (error, errorInfo) => {
        const errorDetails = {
            errorMessage: error?.message || "Unknown error Message",
            error: error || "Unknown error",
            stack: error?.stack || "No stack trace available",
            componentStack: errorInfo?.componentStack || "No component stack available",
            url: window?.location?.href || "Unknown URL",
            userId: profile?.userId || "unknown userId"
        };
        log.error("ErrorBoundary caught error:", JSON.stringify(errorDetails, null, 2));
    };

    return (
        <ErrorBoundary fallbackRender={fallbackRender} onError={handleError}>
            {children}
        </ErrorBoundary>
    );
};

ErrorBoundaryWrapper.propTypes = {
    children: PropTypes.node.isRequired
};

export default ErrorBoundaryWrapper;
